import { CustomBlending, type MeshPhysicalMaterial, OneFactor } from '@seddi/three';
import * as flagsModule from '../flags/flagsModule';
import { FeatureFlag } from '../flags/flagsTypes';

export function configure(self: MeshPhysicalMaterial) {
  self.alphaTest = 0.04;
  self.transparent = true;

  self.defines['UV_NOREPEAT'] = '';

  // Premultiplied alpha blending
  const usePremultipliedAlpha = flagsModule.isEnabled(FeatureFlag.PREMULTIPLIED_ALPHA_LOGOS);
  if (usePremultipliedAlpha) {
    self.blending = CustomBlending;
    self.blendSrc = OneFactor;
  }
}
